var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 491.5 491.5",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#66bb6a",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 96.9c-17.9 0-32.5 14.6-32.5 32.5s14.6 32.5 32.5 32.5 32.5-14.6 32.5-32.5c-.1-18-14.6-32.5-32.5-32.5zm0 74.5c-23.2 0-42.1-18.9-42.1-42.1S44.8 87.2 68 87.2s42.1 18.9 42.1 42.1c-.1 23.2-18.9 42.1-42.1 42.1zM150.9 103.8c-3.3 0-6 2.7-6 6v39.1c0 3.3 2.7 6 6 6H330c3.3 0 6-2.7 6-6v-39.1c0-3.3-2.7-6-6-6zM330 164.6H150.9c-8.6 0-15.6-7-15.6-15.6v-39.1c0-8.6 7-15.6 15.6-15.6H330c8.6 0 15.6 7 15.6 15.6V149c0 8.5-7 15.6-15.6 15.6zM68 213.3c-17.9 0-32.5 14.6-32.5 32.5s14.6 32.5 32.5 32.5 32.5-14.6 32.5-32.5c-.1-17.9-14.6-32.5-32.5-32.5zm0 74.5c-23.2 0-42.1-18.9-42.1-42.1s18.9-42.1 42.1-42.1 42.1 18.9 42.1 42.1c-.1 23.2-18.9 42.1-42.1 42.1zM150.9 220.1c-3.3 0-6 2.7-6 6v39.1c0 3.3 2.7 6 6 6H390c3.3 0 6-2.7 6-6v-39.1c0-3.3-2.7-6-6-6zM390 281H150.9c-8.6 0-15.6-7-15.6-15.6v-39.1c0-8.6 7-15.6 15.6-15.6H390c8.6 0 15.6 7 15.6 15.6v39.1c0 8.5-7 15.6-15.6 15.6zM68 329.7c-17.9 0-32.5 14.6-32.5 32.5s14.6 32.5 32.5 32.5 32.5-14.6 32.5-32.5c-.1-17.9-14.6-32.5-32.5-32.5zm0 74.5c-23.2 0-42.1-18.9-42.1-42.1S44.8 320 68 320s42 19 42 42.2-18.8 42-42 42zM150.9 336.6c-3.3 0-6 2.7-6 6v39.1c0 3.3 2.7 6 6 6H450c3.3 0 6-2.7 6-6v-39.1c0-3.3-2.7-6-6-6zM450 397.4H150.9c-8.6 0-15.6-7-15.6-15.6v-39.1c0-8.6 7-15.6 15.6-15.6H450c8.6 0 15.6 7 15.6 15.6v39.1c0 8.6-7 15.6-15.6 15.6z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#66bb6a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.ea5aac853ccb9aaeafddee83a4fac2be.svg";
export { ForwardRef as ReactComponent };